import type { ReactElement } from "react";
import { CmtsAccessGovernanceContainer } from "../../core/containers/domain/administrationRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsAccessGovernanceContainer runtime={props.runtime} />;
}

export default Component;
